import one from '../Assets/Book-Images/1.png';
import two from '../Assets/Book-Images/2.png';
import three from '../Assets/Book-Images/3.png';
import four from '../Assets/Book-Images/4.png';
import five from '../Assets/Book-Images/5.png'
import six from '../Assets/Book-Images/6.png';
import seven from '../Assets/Book-Images/7.png';
import eight from '../Assets/Book-Images/8.png';
import nine from '../Assets/Book-Images/9.png';
import ten from '../Assets/Book-Images/10.png';
import eleven from '../Assets/Book-Images/11.png';
import twelve from '../Assets/Book-Images/12.png';
import thirteen from '../Assets/Book-Images/13.png';

import Header from '../Components/Header/Header';

const AssetsBook = () => {

   return (
			<div className='Page'>
				<Header />
				<div className='AssetsBook'>
					<img src={one} alt='photo' />
					<hr />
					<img src={two} alt='photo' />
					<hr />
					<img src={three} alt='photo' />
					<hr />
					<img src={four} alt='photo' />
					<hr />
					<img src={five} alt='photo' />
					<hr />
					<img src={six} alt='photo' />
					<hr />
					<img src={seven} alt='photo' />
					<hr />
					<img src={eight} alt='photo' />
					<hr />
					<img src={nine} alt='photo' />
					<hr />
					<img src={ten} alt='photo' />
					<hr />
					<img src={eleven} alt='photo' />
					<hr />
					<img src={twelve} alt='photo' />
					<hr />
					<img src={thirteen} alt='photo' />
				</div>
			</div>
		)
}
export default AssetsBook;